<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6664 14C10.6664 15.3332 9.33359 15.9999 8.00037 16C6.66703 16 5.33337 15.3333 5.33337 14H10.6664ZM8.00037 0C9.32033 0.000215279 9.65983 1.30732 9.66638 1.33301C11.333 1.33301 13.3332 3.33312 13.3334 5.33301V10.667L14.6664 11.333V12.667H1.33337V11.333L2.66638 10.667V5.33301C2.6666 3.33312 4.6668 1.33301 6.33337 1.33301C6.33922 1.31002 6.67873 0 8.00037 0Z"
      fill="#10B981"
    />
  </svg>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    color: {
      type: String,
      default: 'midnight',
    },
  },
}
</script>

<style lang="scss" scoped></style>
